export const USER_TYPE = {
  ADMIN: "ADMIN",
  CONTENT_EDITOR: "CONTENT_EDITOR",
}
